import { ShiftTimeMapping, ShiftTimeConfig } from './types';

export const defaultCaseyMappings: ShiftTimeMapping[] = [
  { code: 'AM', startTime: '0800', endTime: '1730', isOvernight: false, label: 'AM Shift' },
  { code: 'AM-AC', startTime: '0800', endTime: '1730', isOvernight: false, label: 'AM AC' },
  { code: 'AM-CC', startTime: '0800', endTime: '1730', isOvernight: false, label: 'AM CC' },
  { code: 'AM-MIC', startTime: '0800', endTime: '1730', isOvernight: false, label: 'AM MIC' },
  { code: 'AM-PD', startTime: '0800', endTime: '1730', isOvernight: false, label: 'AM PD' },
  { code: 'AM730', startTime: '0730', endTime: '1700', isOvernight: false, label: 'AM730 Shift' },
  { code: 'AM730-PD', startTime: '0730', endTime: '1700', isOvernight: false, label: 'AM730 PD' },
  { code: 'AM730-SS', startTime: '0730', endTime: '1700', isOvernight: false, label: 'AM730 SS' },
  { code: 'PM', startTime: '1430', endTime: '0000', isOvernight: true, label: 'PM Shift' },
  { code: 'PM-AC', startTime: '1430', endTime: '0000', isOvernight: true, label: 'PM AC' },
  { code: 'PM-CC', startTime: '1430', endTime: '0000', isOvernight: true, label: 'PM CC' },
  { code: 'PM-MIC', startTime: '1430', endTime: '0000', isOvernight: true, label: 'PM MIC' },
  { code: 'PM-PD', startTime: '1430', endTime: '0000', isOvernight: true, label: 'PM PD' },
  { code: 'PM-IC', startTime: '1430', endTime: '0000', isOvernight: true, label: 'PM IC' },
  { code: 'Night', startTime: '2300', endTime: '0830', isOvernight: true, label: 'Night Shift' },
  { code: 'Night-IC', startTime: '2300', endTime: '0830', isOvernight: true, label: 'Night IC' },
  { code: 'Night MT-IC', startTime: '2300', endTime: '0830', isOvernight: true, label: 'Night MT-IC' },
  { code: 'Flex10', startTime: '1000', endTime: '1930', isOvernight: false, label: 'Flex10 Shift' },
  { code: 'Flex10-AC', startTime: '1000', endTime: '1930', isOvernight: false, label: 'Flex10 AC' },
  { code: 'Flex10-CC', startTime: '1000', endTime: '1930', isOvernight: false, label: 'Flex10 CC' },
  { code: '0730', startTime: '0730', endTime: '1700', isOvernight: false, label: '0730 Shift' },
];

export const defaultVhhMappings: ShiftTimeMapping[] = [
  { code: 'CST', startTime: '0800', endTime: '1730', isOvernight: false, label: 'CST Shift' },
  { code: 'AM SMS', startTime: '0800', endTime: '1730', isOvernight: false, label: 'AM SMS Shift' },
  { code: 'AM REG', startTime: '0800', endTime: '1730', isOvernight: false, label: 'AM REG Shift' },
  { code: 'SSU HMO (8-4)', startTime: '0800', endTime: '1600', isOvernight: false, label: 'SSU HMO (8-4)' },
  { code: 'AM JMS', startTime: '0800', endTime: '1730', isOvernight: false, label: 'AM JMS Shift' },
  { code: 'MED STUDENT', startTime: '0800', endTime: '1600', isOvernight: false, label: 'MED STUDENT' },
  { code: 'SWING', startTime: '1000', endTime: '1930', isOvernight: false, label: 'SWING Shift' },
  { code: 'SWING 1230PM', startTime: '1230', endTime: '2200', isOvernight: false, label: 'SWING 1230PM' },
  { code: 'PM SMS', startTime: '1430', endTime: '0000', isOvernight: true, label: 'PM SMS Shift' },
  { code: 'PM REG', startTime: '1430', endTime: '0000', isOvernight: true, label: 'PM REG Shift' },
  { code: 'PM JMS', startTime: '1430', endTime: '0000', isOvernight: true, label: 'PM JMS Shift' },
  { code: 'ON REG', startTime: '2300', endTime: '0830', isOvernight: true, label: 'ON REG Shift' },
  { code: 'ON JMS', startTime: '2300', endTime: '0830', isOvernight: true, label: 'ON JMS Shift' },
];

export function getDefaultConfig(): ShiftTimeConfig {
  return {
    mmc: [],
    casey: defaultCaseyMappings,
    vhh: defaultVhhMappings,
  };
}